export default __webpack_public_path__ + "f77520023db7bbc3653ef5df70230dc1.webp";